// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"also-watch-m__wrapper__2680r","player":"also-watch-m__player__1YBYW","logo-wrapper":"also-watch-m__logo-wrapper__3i0Kg","logo":"also-watch-m__logo__2dX7w"};